import React from 'react';

export default function CasinoSportBookModuleLoader() {
    return (
        <div className="hp-casino-module">
            <div className="casino-lobby-module wave-animation" style={{ height: 20, width: '50%', borderRadius: 4 }} />
            <div className="casino-lobby-module wave-animation" style={{ height: 80, borderRadius: 4 }} />
        </div>
    );
}
